import { justNumbers } from "./parser"

/**
 * Checa se o CPF é válido
 */
export function isValidCpf(strCPF) {

    strCPF = justNumbers(strCPF)

    let soma = 0
    let resto

    const invalids = [
        '00000000000',
        '11111111111',
        '22222222222',
        '33333333333',
        '44444444444',
        '55555555555',
        '66666666666',
        '77777777777',
        '88888888888',
        '99999999999',
    ]

    if (invalids.includes(strCPF)) return false

    for (let i = 1; i <= 9; i++) soma = soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i)
    resto = (soma * 10) % 11

    if ((resto == 10) || (resto == 11)) resto = 0
    if (resto != parseInt(strCPF.substring(9, 10))) return false

    soma = 0
    for (let i = 1; i <= 10; i++) soma = soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i)
    resto = (soma * 10) % 11

    if ((resto == 10) || (resto == 11)) resto = 0
    if (resto != parseInt(strCPF.substring(10, 11))) return false

    return true

}
function calculateCheckDigit(baseString, weights) {

    let sum = 0
    for (let i = 0; i < baseString.length; i++) {
        const charValue = baseString.charCodeAt(i) - 48
        sum += charValue * weights[i]
    }

    const remainder = sum % 11
    return remainder < 2 ? 0 : 11 - remainder

}

export function isValidCnpj(cnpj) {

    const rawCleanedCnpj = cnpj.replace(/[^A-Za-z0-9]/g, '')

    if (/[a-z]/.test(rawCleanedCnpj)) return false

    const cleanedCnpj = rawCleanedCnpj.toUpperCase()

    if (cleanedCnpj.length !== 14) return false
    if (/^([A-Z0-9])\1{13}$/.test(cleanedCnpj)) return false

    const weightsFirstDigit = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
    const baseString = cleanedCnpj.substring(0, 12)
    const firstDigit = calculateCheckDigit(baseString, weightsFirstDigit)

    const weightsSecondDigit = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
    const secondDigit = calculateCheckDigit(baseString + firstDigit, weightsSecondDigit)

    return cleanedCnpj.endsWith(`${firstDigit}${secondDigit}`)

}